import {isNil} from 'ramda';

import i18n from '@dms/i18n';

const RENTAL_CODELIST_LABEL_KEYS = new Map([
  ['vehicleCategory', 'entity.rental.labels.vehicleCategory'],
  ['cancellationReason', 'entity.rental.labels.cancellationReason'],
  ['vehicleBlock', 'entity.rental.labels.vehicleBlock'],
]);

export function getRentalCodelistLabel(codelistId: string, fallbackName: string) {
  const translationKey = RENTAL_CODELIST_LABEL_KEYS.get(codelistId);

  return isNil(translationKey) ? fallbackName : i18n.t(translationKey);
}
